import {
  UserTemplateServiceRequest,
  UserTemplateServiceResponse,
  UserTemplateServiceViewModel,
} from "@/services/userTemplateService.types";

export function transformResponseToUserTemplateViewModel(
  reportStyleApi?: UserTemplateServiceResponse | null
): UserTemplateServiceViewModel {
  return {
    generalInstructions: reportStyleApi?.general?.instructions || "",
    defaultConcision: Number(reportStyleApi?.general?.concision?.value ?? 50),
    preferredTerminology: Array.isArray(reportStyleApi?.general?.terminology?.preferred)
      ? reportStyleApi.general.terminology.preferred.join(", ")
      : "",
    concisionExamples: reportStyleApi?.general?.concisionExamples || {},
  };
}

export function transformViewModelIntoUserTemplateRequest(
  userTemplateViewModel: UserTemplateServiceViewModel
): UserTemplateServiceRequest {
  return {
    general: {
      instructions: userTemplateViewModel.generalInstructions,
      concision: {
        level:
          userTemplateViewModel.defaultConcision < 33
            ? "detailed"
            : userTemplateViewModel.defaultConcision < 66
              ? "moderate"
              : "concise",
        value: Number(userTemplateViewModel.defaultConcision),
      },
      terminology: {
        preferred: userTemplateViewModel.preferredTerminology
          .split(",")
          .map((term) => term.trim())
          .filter(Boolean),
        avoided: [],
      },
      concisionExamples: userTemplateViewModel.concisionExamples || {},
    },
  };
}
